import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setDialogAction,
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { DialogsEnum } from '@/enums'
import ActionTypes from '../constants'
import { SaveExcludedGamesPayload, ExcludedGamesState } from '../models'

import { EXCLUDED_GAMES } from './api.routes'
import { getExcludedGamesThunk } from './get-excluded-games.thunk'

const apiService: RestApiService = Container.get(RestApiService)

export const saveExcludedGamesThunk = createAsyncThunk(
  ActionTypes.SAVE_EXCLUDED_GAMES,
  async (payload: SaveExcludedGamesPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'POST',
        endpoint: EXCLUDED_GAMES.SAVE_EXCLUDED_GAMES,
        body: payload,
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: any = await apiService.sendData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('labels.excludedGames')}`,
        what: i18n.t('labels.updated'),
      })

      if (
        (response.statusCode && response.statusCode !== 200) ||
        (response.status && response.status !== 200)
      ) {
        message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')
      } else {
        thunkAPI.dispatch(getExcludedGamesThunk({}))
        thunkAPI.dispatch(
          setDialogAction({
            open: false,
            id: DialogsEnum.DIALOG_EXCLUDED_GAMES_FORM,
          }),
        )
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant:
            (response.statusCode && response.statusCode !== 200) ||
            (response.status && response.status !== 200)
              ? 'error'
              : 'success',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const saveExcludedGamesExtraReducer = (
  builder: ActionReducerMapBuilder<ExcludedGamesState>,
) => {
  builder.addCase(saveExcludedGamesThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(saveExcludedGamesThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
  })
}

export default saveExcludedGamesExtraReducer
